<template>
  <div
    class="ui-list__header"
    :class="headerClass"
  >
    {{ name }}
  </div>
</template>

<script setup lang="ts">
type Props = {
  name: string
  headerClass?: string
}

defineProps<Props>()
</script>

<style>
.ui-list {
  &__header {
    @apply sticky top-0 z-10;
    @apply flex items-center;
    @apply py-2 px-1;
    @apply bg-body;
    @apply border-b border-common-border;
    @apply text-light-text;
    @apply font-medium uppercase;
    @apply tracking-wider;
    @apply text-sm sm:text-xs;
  }
}
</style>
